import { Ref, ref, watchEffect } from 'vue';


export function useDistanceFromTop(el: Ref<HTMLElement | null>) {
	const distanceFromTop = ref('200px');

	function recalculate(el: HTMLElement) {
		const viewRect = el.getBoundingClientRect();
		const bodyRect = document.documentElement.getBoundingClientRect();

		distanceFromTop.value = `${Math.abs(viewRect.top - bodyRect.top)}px`;
	}

	watchEffect((onCleanup) => {
		if (!el.value) {
			return;
		}

		recalculate(el.value);

		const resizeAbortController = new AbortController();
		window.addEventListener('resize', () => {
			if (el.value) {
				recalculate(el.value);
			}
		}, {
			passive: true,
			signal: resizeAbortController.signal,
		});
		onCleanup(() => resizeAbortController.abort());
	});

	return { distanceFromTop };
}